module.exports = __webpack_public_path__ + "img/app3.85f16169.png";